import React, { useCallback, useMemo } from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import GetAppIcon from '@material-ui/icons/GetApp';
import MicIcon from '@material-ui/icons/Mic';
import { HtmlTooltip } from 'components/Tooltip';
import WkblVideoVO from 'commons/vo/WkblVideoVO';
import { Highlight } from './Icon';
import { useAsset } from 'hooks';
import { makeStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

export interface DownloadAssetSplitButtonProps {
  asset: WkblVideoVO;
  onDownloadClick: (event: React.MouseEvent) => void;
  isListView?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  buttonContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '2px'
  },
  buttonText: {
    fontSize: 8,
    whiteSpace: 'nowrap'
  }
}))

function DownloadAssetSplitButton({
  asset,
  onDownloadClick,
  isListView,
}: DownloadAssetSplitButtonProps) {
  const classes = useStyles();

  const {
    onRequestInterviewDownloadCloudfront,
    onRequestHighlightDownloadCloudfront
  } = useAsset();

  const interviewFilename = useMemo(() => {
    return asset.interviewPartialFilename;
  }, [asset]);

  const highlightFilename = useMemo(() => {
    return asset.highlightPartialFilename;
  }, [asset]);

  const onDownloadInterviewClick = useCallback(() => {
    onRequestInterviewDownloadCloudfront({
      downloadUrl: interviewFilename,
    })
  }, [asset])

  const onDownloadHighlightClick = useCallback(() => {
    onRequestHighlightDownloadCloudfront({
      downloadUrl: highlightFilename,
    })
  }, [asset])

  return (
    <>
      <ButtonGroup
        size="small"
        variant={isListView ? 'text' : 'outlined'}
        style={{ height: 46, ...(isListView && { width: '120px' }) }}
      >
        {interviewFilename && (
          <HtmlTooltip title="인터뷰 다운로드">
            <Button fullWidth onClick={onDownloadInterviewClick}>
              <div className={clsx(classes.buttonContent)}>
                <MicIcon fontSize="small" />
                <div className={clsx(classes.buttonText)}>인터뷰</div>
              </div>
            </Button>
          </HtmlTooltip>
        )}
        {highlightFilename && (
          <HtmlTooltip title="하이라이트 다운로드">
            <Button fullWidth onClick={onDownloadHighlightClick}>
              <div className={clsx(classes.buttonContent)}>
                <Highlight width="20px" height="18px" color="#000000" />
                <div className={clsx(classes.buttonText)}>H/L</div>
              </div>
            </Button>
          </HtmlTooltip>
        )}
        <HtmlTooltip title="전체 다운로드">
          <Button fullWidth onClick={onDownloadClick}>
            <div className={clsx(classes.buttonContent)}>
              <GetAppIcon fontSize="small" />
              <div className={clsx(classes.buttonText)}>전체</div>
            </div>

          </Button>
        </HtmlTooltip>
      </ButtonGroup>
    </>
  );
}

export default DownloadAssetSplitButton;
